import React from 'react';
import {Modal, Button, Table} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {Line} from 'react-chartjs-2';
import {inject} from 'mobx-react';
import moment from 'moment'
import {injectIntl} from 'react-intl';

@injectIntl @inject("growStore")
export default class StartupModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {active: true}

    }

    render() {

        const {growStore} = this.props;
        const {intl} = this.props;

        if (!growStore.loaded) {
            return <div className="main-loader">
                <div className="loader-lg"></div>
            </div>
        }

        const id = this.props.match.params.id;
        const startup = growStore.findStartupById(id);
        const data = growStore.getData(id, intl.formatMessage({id: "lpl_label"})); 
        
        return (
            <div>
                <Modal show={this.state.active}
                       onHide={() => {
                           this.setState({active: false})

                       }}
                       container={this.props.container}
                       aria-labelledby="contained-modal-title"
                       backdrop={'static'}
                       keyboard={false}>

                    <LinkContainer to='/startup_statistics/grow' exact>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {startup.name}
                            </Modal.Title>
                        </Modal.Header>
                    </LinkContainer>

                    <Modal.Body>

                        <Table striped responsive>
                            <thead>
                                <tr>
                                    <td>{intl.formatMessage({id: "member_label"})}</td>
                                    <td>{intl.formatMessage({id: "role_label"})}</td>
                                </tr>
                            </thead>

                            <tbody>
                            {
                                startup.startup_members.map((p, idx) => {
                                    return (<tr key={idx}>
                                        <td>{p.user.name}</td>
                                        <td>{intl.formatMessage({id: p.role})}</td>
                                    </tr>)
                                })
                            }
                            </tbody>
                        </Table>
                        <Line data={data}/>
                        <h4 className={"text-center"}>{intl.formatMessage({id: "general_statistics_title"})}</h4>

                        <Table responsive condensed>
                            <tbody>
                            <tr>
                                <td><span className={"bold"}>{intl.formatMessage({id: "current_vp_label"})}</span></td>
                                <td>{startup.value_proposition.current_vp}</td>
                            </tr>
                            <tr>
                                <td><span className={"bold"}>{intl.formatMessage({id: "current_mvp_label"})}</span></td>
                                <td>{startup.value_proposition.current_mvp}</td>
                            </tr>
                            <tr>
                                <td><span className={"bold"}>{intl.formatMessage({id: "current_members_label"})}</span></td>
                                <td>{startup.startup_members.length}</td>
                            </tr>
                            </tbody>

                        </Table>

                        <h4 className={"text-center"}>{intl.formatMessage({id: "tools_info"})}</h4>

                        <Table responsive>
                            <thead>
                            <tr>
                                <td className={"bold text-center"}>{intl.formatMessage({id: "tool_label"})}</td>
                                <td className={"bold text-center"}>{intl.formatMessage({id: "average_usage_label"})}</td>
                            </tr>
                            </thead>

                            <tbody>

                            {
                                startup.timeTracker.tools.map((p, id) => {
                                    return (<tr key={id}>
                                        <td className={"text-center"}>{intl.formatMessage({id: p[0]})}</td>
                                        <td className={"text-center"}>{moment.utc(p[1] * 1000).format('HH:mm:ss')}</td>
                                    </tr>)
                                })
                            }
                            </tbody>

                        </Table>

                    </Modal.Body>

                    <Modal.Footer>
                        <LinkContainer to='/startup_statistics/grow' exact>
                            <Button onClick={() => {
                                this.setState({active: false})
                            }}>
                                {intl.formatMessage({id: "close_modal"})}
                            </Button>
                        </LinkContainer>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}